import { render, staticRenderFns } from "./DaftarGadaiAktif.vue?vue&type=template&id=dc151452&scoped=true&"
import script from "./DaftarGadaiAktif.vue?vue&type=script&lang=js&"
export * from "./DaftarGadaiAktif.vue?vue&type=script&lang=js&"
import style0 from "./DaftarGadaiAktif.vue?vue&type=style&index=0&id=dc151452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc151452",
  null
  
)

export default component.exports